import { useState, useEffect } from 'react';
import { AdminContextProps } from '../../../types/admin';

interface UseAttributePathOptions extends AdminContextProps {
  attributePath: string
  defaultValue: any
};
// {
//   attributePath, getObjectAttribute, updateObjectAttribute, defaultValue
// }
export function useAttributePath(props: UseAttributePathOptions) {
  const [keyExists, setKeyExists] = useState(() => {
    return props.getObjectAttributeExists(props.attributePath) || false;  
  });

  const [value, setValue] = useState(() => {
    if (keyExists) {  // If the key exists, use the attribute value.
      return props.getObjectAttribute(props.attributePath);
    } else {  // If the key doesn't exist, use the defaultValue.
      return props.defaultValue;
    }
  });

  useEffect(() => {
    if (keyExists) {
      let attributeValue
      attributeValue = props.getObjectAttribute(props.attributePath);
      setValue(attributeValue);
    }
  }, [props.attributePath, props.getObjectAttribute, keyExists]);

  const handleUpdateAttribute = (newValue: any) => {
    props.updateObjectAttribute(props.attributePath, newValue);
    setValue(newValue);  // Update local state with the new value.
    setKeyExists(true);  // Since we've set a value, the key now exists.
  };

  return {
    value,
    updateAttribute: handleUpdateAttribute,
    keyExists
  };
}

